import type { Marker, MarkerFormatter, Rectangle } from '@libs/maps';

export interface MapConfig {
  markers?: Marker;
  markerFormatters?: Partial<MarkerFormatter>;
  startRectangle?: Rectangle;
}

export const enum MapType {
  Static = 'StaticMap',
  Dynamic = 'DynamicMap',
}
